module.exports = __webpack_public_path__ + "img/pic.4d3ced39.png";